module.exports = __webpack_public_path__ + "static/media/PayPal.633a2b88.svg";